import { useAuth0 } from "@auth0/auth0-react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import OpenInNewOutlinedIcon from "@material-ui/icons/OpenInNewOutlined";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { MyCheckbox } from "components";
import Action from "components/ActionPopOver";
import React, { memo, useEffect, useMemo, useState } from "react";
import AlertDialog from "../../../components/Dialog";
import MyModal from "../../../components/MyModal";
import FinanceService from "../../../Lib/API/Finance/index";
import ChargesTable from "../TransactionsTable";

import { CircularProgress } from "@mui/material";
import { ReactComponent as InstallmentIcon } from "assets/icons/recurring-icon.svg";
import MainDialog from "components/Dialog/MainDialog";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import moment from "moment";
import { toastr } from "react-redux-toastr";
import { DateFormetContext } from "../../../app/App.js";
import { CheckFloatValue } from "../../../utils/functions";
import ApplyLink from "./ApplyLink";
import BulkPaymentTable from "./BulkPaymentTable";

const recurringStatusColor = {
  active: "#81DC91",
  "on-hold": "#2555ef21",
  declined: "#fd02027d",
  disable: "#fd02027d",
};
const MOCK_SINGLE_PAYMENT = [
  {
    _id: "payment_123",
    isBulkPayment: true,

    charge_type: "payment",
    payment_status: "Paid",

    createdAt: "2026-01-20T06:30:00.000Z",

    Account: {
      id: "acc_1",
      name: "Test User",
      payment: {
        account_type: "member",
      },
    },

    Ledger: {
      name: "General Ledger",
    },

    SubLedger: {
      name: "Online Payments",
    },

    charged: 500,
    paid: 500,

    charge: {
      _id: "charge_123",
      status: "payment",
      amount: 500,
      paid: 500,
      discount: 0,
      due_date: "2026-01-25T00:00:00.000Z",

      payment: {
        status: "close",
        History: [
          {
            _id: "history_1",
            amount: 500,
            created_at: "2026-01-20T06:30:00.000Z",
            is_reversed: false,
            paymnetMethod: {
              method: "card",
            },
          },
        ],
      },
    },
  },
];

const ExpandableRow = (props) => {
  const {
    row,
    Enableloading,
    hideAccountName = false,
    batchbillingShow = false,
    index,
    modifyRowData,
    onCheckboxChange,
    check,
    onSharePaymentLinkClick,
    onPayNowClick,
    onUpdateClick,
    onDeleteClick,
    onReversalClick,
    setDrawerData,
    setOpenModal,
    batchTable,
    financeCheckIds,
    paymentExpandable,
    setPaymentExpandable,
    setBatchList,
    page,
    transactionId,
    checkData,
    expandable,
    setExpandable,
    setcheckCreateAccount,
    checkCreateAccount,
    setPaymentAction,
    onPayAllClick,
    bulkPayment,
    disableSharePaymentLink,
    onCancelPayment,
    onUpdatePaymentMethodClick,
     showSelection=true,


  } = props;
  const [disabledKey, setDisable] = useState(true);
  const dateFormet = React.useContext(DateFormetContext);
  const [open, setOpen] = React.useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [reversalActionTypes, setReversalActionTypes] = useState(false);
  const [getTypes, setActionTypes] = useState([]);
  const [paymentId, setPaymentId] = useState();
  const [chargeId, setchargeId] = useState();
  const [reversalDialog, setReversalDialog] = useState(false);
  const [dialogPaymentId, setDialogPaymentId] = useState();
  const [confirmBulkReversal, setConfirmBulkReversal] = useState(false);
  const [openAddModel, setOpenAddModel] = React.useState(false);
  const [recurringAction, setRecurringAction] = useState("");
  const [bulkPayments, setBulkPayments] = useState("");
  const [bulkPaymentLoading, setBulkPaymentLoading] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const [loading, setLoading]= useState(false)

  useEffect(() => {
    if (recurringAction === "") return;
    onSelectedPayment(row, recurringAction);
  }, [recurringAction]);
  const [openCancleModalDialog, setOpenCancleModalDialog] =
    React.useState(false);

  const handelSubmit = () => {
    setRecurringAction("disable");
  };

  const onSelectedPayment = async (row) => {
    const payload = {
      transactionId: row?._id ?? "64620154b09a58002fc35dd2",
      status: recurringAction,
    };

    const token = await getAccessTokenSilently();
    await FinanceService.PaymentInfoAction(payload, token)
      .then((res) => {
        setPaymentAction(true);
        setOpenCancleModalDialog(false);
        toastr.success(res.message ?? "Action Successfully Completed!");
      })
      .catch((error) => {
        setPaymentAction(true);
        toastr.error(error?.data?.message);
      });
  };

  const onCancelClick = async () => {
    setOpenCancleModalDialog(true);
  };

  const fetchReversalTypes = async (type, Id1, Id2) => {
    setchargeId(Id1);
    setPaymentId(Id2);
    const token = await getAccessTokenSilently();
  
    await FinanceService.getAllReversalTypes(type, token)
      .then((res) => {
        setActionTypes(res?.result);
      })
      .catch((error) => {
        console.log(error);
        toastr.error(error?.data?.message);
      });
    setReversalActionTypes(true);
  };

  const handleCloseDialog = () => {
    setReversalActionTypes(false);
    setOpenCancleModalDialog(false);
  };

  useEffect(() => {
    if (expandable === false) {
      setOpen(false);
      setExpandable(true);
    }
  }, [expandable]);

  useEffect(() => {
    if (paymentExpandable === false) {
      setOpen(false);
      setPaymentExpandable(true);
    }
  }, [paymentExpandable]);

  const filteredCharge = checkData?.map((item) => {
    return transactionId?.includes(item?._id);
  });
  const getCommaSeperatedValue = (num) => {
    return CheckFloatValue(num)
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const getBulkPaymentsById = async (id) => {
    setBulkPayments("");
    const token = await getAccessTokenSilently();
    try {
      setBulkPaymentLoading(true);
      const res = await FinanceService.getBulkPaymentsById(id, token);
      setBulkPayments(res);
    } catch (error) {
      toastr.error("Error", error?.data?.message);
    } finally {
      setBulkPaymentLoading(false);
    }
  }

  const isFutureDate = (date) => {
    const currentDate = moment();
    const futureDate = moment(date);
    return futureDate.isAfter(currentDate);
  }

  const displayChargeTransactionLine2 = (row) => {
    let currentStatus = "Open";
    if (
      row?.charge?.status === "payment" &&
      row?.charge?.payment?.status === "partialy_applied"
    ) {
      currentStatus = "Partially Paid";
    }
    if (
      row?.charge?.status === "payment" &&
      row?.charge?.payment?.status !== "partialy_applied"
    ) {
      currentStatus =
        row?.charge?.payment?.status === "close"
          ? "Closed"
          : row?.charge?.sub_status === "close"
          ? "Closed"
          : "Open";
    }
    if (row?.Charges?.amount_due === 0) currentStatus = "Closed";
    return currentStatus;
  };

  const displayPaymentTransactionLine2 = (row) => {
    const status = row?.transaction?.charge?.sub_status;
    let currentStatus = "Open";
    switch (status) {
      case "closed":
        currentStatus = "Closed";
        break;
      case "partially_paid":
        currentStatus = "Partially Paid";
        break;
      default:
        currentStatus = "Open";
        break;
    }
    return currentStatus;
  };

  const displayInstallmentStatus = (row) => {
    const status = row?.status;
    switch (status) {
      case "active":
        return "Installments Active";
      case "disable":
        return "Installments Disabled";
      case "on-hold":
        return "Installments On-hold";
      case "completed":
        return "Installments Completed";
      default:
        return "Installments Active";
    }
  };

  const displayRecurringStatus = (row) => {
    const status = row?.recurringDetails?.recurringStatus;
    switch (status) {
      case "active":
        return "Recurring Active";
      case "declined":
        return "Recurring Declined";
      case "on-hold":
        return "Recurring On-hold";
      case "disable":
        return "Recurring Disabled";
      default:
        return "";
    }
  };

  const closeModal = () => {
    setConfirmClose(true);
  };
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenAddModel(false);
  };

  const enableUpdatePaymentMethod = useMemo(() => {
    return (
      (row?.isRecurring &&
        row?.recurringDetails?.recurringStatus === "active") ||
      (row?.charge?.isInstallment &&
        row?.charge?.installmentDetails?.status === "active")
    );
  }, [row]);

  return (
    <React.Fragment>
      <TableRow
        key={index}
        sx={{ "& > *": { borderBottom: "unset" } }}
        className={
          (row.charge?.payment?.History?.length === 1 ||
            row.charge?.payment?.History?.length > 1) &&
          open === true
            ? "exp_head"
            : ""
        }
      >
        {showSelection && batchTable !== "batchtable" && (
        
          <TableCell
            width="10%"
            className="main-check main-width-class"
            style={{
              pointerEvents: bulkPayment ? "none" : "initial",
            }}
            padding="checkbox"
          >
            <MyCheckbox
              name={"visible"}
              handlechange={(e) => onCheckboxChange(e, row, index, page)}
              disabled={false}
              checked={
                !!check.includes(index) ||
                !!check?.includes(row?.charge?._id) ||
                !!(
                  filteredCharge?.[0] &&
                  check &&
                  check?.includes(row?.charge?._id) &&
                  financeCheckIds?.includes(row?.Account?.id)
                )
              }
            />
          </TableCell>
        )}
        {row.charge?.payment?.History?.length >= 1 ||
        (bulkPayment && row?.isBulkPayment) ? (
          
          <TableCell width="10%" className="expand-button main-width-class">
            
            <IconButton
              aria-label="expand ro w"
              size="large"
              onClick={() => {
              
                if (!open && bulkPayment && row?.isBulkPayment) {
               
                  getBulkPaymentsById(row?.bulkPaymentId);
                }
                setOpen(!open);
              }}
              className="expandale-icon"
            >
              {open ? (
                <IndeterminateCheckBoxOutlinedIcon />
              ) : (
                <AddBoxOutlinedIcon />
              )}
            </IconButton>
          </TableCell>
        ) : (
          <TableCell
            width="10%"
            className="table-cell-remove main-width-class"
          />
        )}

        {row?.isRecurring ? (
          <TableCell
            className="main-width-class"
            width="5%"
            component="th"
            scope="row"
            onClick={() => {
              setOpen(true);
              setDrawerData(row);
              setOpenModal(true);
            }}
          >
            <div
              className={"recurring_indicator"}
              style={{
                backgroundColor:
                  recurringStatusColor[
                    row?.recurringDetails?.recurringStatus
                  ] || "#2555ef21",
              }}
            >
              <svg
                width="9"
                height="9"
                viewBox="0 0 9 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.5 0C2.02085 0 0 2.02085 0 4.5C0 6.9795 2.02085 9 4.5 9C6.76904 9 8.65385 7.308 8.95673 5.1165C8.96954 5.04742 8.96819 4.97646 8.95277 4.90791C8.93736 4.83937 8.90819 4.77466 8.86703 4.71772C8.82588 4.66078 8.7736 4.61278 8.71336 4.57663C8.65311 4.54048 8.58616 4.51693 8.51655 4.50741C8.44694 4.4979 8.37612 4.5026 8.30838 4.52125C8.24064 4.5399 8.1774 4.5721 8.12247 4.6159C8.06754 4.65971 8.02207 4.71421 7.98881 4.7761C7.95556 4.83798 7.93521 4.90598 7.929 4.97596C7.69604 6.66173 6.25535 7.96154 4.5 7.96154C2.58231 7.96154 1.03846 6.41804 1.03846 4.5C1.03846 2.58231 2.58231 1.03846 4.5 1.03846C5.62015 1.03846 6.61465 1.56981 7.24777 2.39054L6.63092 3.00738C6.579 3.05931 6.5655 3.14273 6.58765 3.21265C6.60842 3.28258 6.66692 3.32758 6.73927 3.34246C7.67285 3.52592 8.74938 3.44492 8.79438 3.43973C8.84 3.43151 8.88176 3.40881 8.91346 3.375C8.94462 3.34454 8.97231 3.31269 8.97854 3.26665C8.98373 3.22165 9.06508 2.13577 8.88092 1.20081C8.87544 1.166 8.8604 1.13339 8.83748 1.10663C8.81456 1.07986 8.78466 1.05998 8.75112 1.04919C8.6805 1.02773 8.59742 1.04054 8.54585 1.09246L7.98335 1.65496C7.15777 0.647308 5.90088 0 4.5 0Z"
                  fill="#3C4467"
                />
              </svg>
            </div>
          </TableCell>
        ) : (
          <TableCell
            className="main-width-class"
            width="5%"
            component="th"
            scope="row"
            onClick={() => {
              setDrawerData({ ...row, bulkPaymentFlag: bulkPayment });
              setOpenModal(true);
            }}
          >
            {""}
          </TableCell>
        )}

        {!bulkPayment && (
          <TableCell
            className="status-head main-width-class"
            width="15%"
            component="th"
            scope="row"
            onClick={() => {
              setOpen(true);
              setDrawerData(row);
              setOpenModal(true);
            }}
          >
            <div className="transaction-status">
              {row.payment_status === "Pending" ? (
                <div className="add-div">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.8808 6.49945H6.5002V10.8801C6.5002 11.2255 6.21984 11.5059 5.8744 11.5059C5.52896 11.5059 5.2486 11.2255 5.2486 10.8801V6.49945H0.867989C0.522546 6.49945 0.242188 6.21909 0.242188 5.87365C0.242188 5.52821 0.522546 5.24785 0.867989 5.24785H5.2486V0.867239C5.2486 0.521796 5.52896 0.241438 5.8744 0.241438C6.21984 0.241438 6.5002 0.521796 6.5002 0.867239V5.24785H10.8808C11.2263 5.24785 11.5066 5.52821 11.5066 5.87365C11.5066 6.21909 11.2263 6.49945 10.8808 6.49945Z"
                      fill="#3F4255"
                    />
                  </svg>
                </div>
              ) : (
                <div style={{ width: 22 }}></div>
              )}

              <div className="pl-0">
                <div
                  className="status"
                  style={
                    row.charge_type === "charge" ||
                    row.charge_type === "donation" ||
                    row.charge_type === "credit_on_account"
                      ? { color: "#FBA12C" }
                      : row.charge_type === "payment"
                      ? { color: "#81DC91" }
                      : {}
                  }
                >
                  {row?.charge_type?.replaceAll("_", " ")?.toUpperCase()}
                </div>
                <div className="transaction-account-name transaction-status-text table-row  text-capitalize">
                  {displayChargeTransactionLine2(row)}
                </div>
                <div className="sub-status table-row ">
                  {row?.charge?.installmentDetails?.status
                    ? displayInstallmentStatus(row?.charge?.installmentDetails)
                    : ""}
                  {row?.isRecurring ? displayRecurringStatus(row) : ""}
                </div>
              </div>
            </div>
          </TableCell>
        )}
        <TableCell
          className="main-width-class"
          onClick={() => {
            setDrawerData({ ...row, bulkPaymentFlag: bulkPayment });
            setOpenModal(true);
          }}
        >
          {bulkPayment ? (
            <div>
              {formatDate({
                date:
                  row?.charge?.payment?.History?.created_at ?? row?.created_at,
                formatType: "defaultWithUTC",
              })}
            </div>
          ) : (
            <div className="transaction-led-sub table-row text-left">
              <p className="sub transaction-date">
                {formatDate({
                  date:
                    batchTable === "batchtable"
                      ? row?.date ?? row?.createdAt
                      : row?.createdAt,
                  formatType: "defaultWithUTC",
                })}
              </p>
            </div>
          )}
        </TableCell>
        <TableCell
          className="main-width-class"
          align="center"
          onClick={() => {
            setDrawerData({ ...row, bulkPaymentFlag: bulkPayment });
            setOpenModal(true);
          }}
        >
          <div className="transaction-led-sub table-row text-left">
            <div className="sub transaction-date">
              {row?.charge?.due_date && !row?.isBulkPayment
                ? formatDate({
                    date: row?.charge?.due_date,
                    formatType: "defaultWithUTC",
                  })
                : "-"}
            </div>
          </div>
        </TableCell>
        {!hideAccountName && (
          <TableCell className="account-header main-width-class" align="left">
            {" "}
            {row?.Account?.payment?.account_type === "visitor" ||
            row?.Account?.payment?.account_type === "registration" ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  gap: "5px",
                }}
              >
                <div
                  className="transaction-account-name visitor_style"
                  onClick={() => {
                    setDrawerData(row);
                    setOpenModal(true);
                  }}
                >
                  {row?.Account?.payment?.account_type === "visitor"
                    ? "Visitor"
                    : "Registration"}
                </div>
                <div
                  className="apply_link"
                  onClick={() => setOpenAddModel(true)}
                >
                  Apply
                </div>
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <div className="transaction-account-name transaction-account-name-text ellipsDueAmount">
                  {row?.Account?.name}
                </div>
                {(row?.Account?.id ?? row?.Account?._id) && (
                  <a
                    href={`/member-details/${row?.Account?.id ?? row?.Account?._id}`}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    style={{ display: "flex", alignItems: "center", color: "#2555EF", flexShrink: 0 }}
                  >
                    <OpenInNewOutlinedIcon style={{ fontSize: 10, width: 18, height: 18 }} />
                  </a>
                )}
              </div>
            )}
          </TableCell>
        )}
        <MyModal
          className="invite-modal"
          open={openAddModel}
          onClose={closeModal}
        >
          <ApplyLink
            closeModal={() => {
              setOpenAddModel(false);
            }}
            row={row}
            setcheckCreateAccount={setcheckCreateAccount}
            checkCreateAccount={checkCreateAccount}
          />
        </MyModal>

        {/* {
          bulkPayment &&
          <TableCell
            onClick={() => {
              setDrawerData({ ...row, bulkPaymentFlag: bulkPayment });
              setOpenModal(true);
            }}
          >
            {row?.charge?.payment?.status && !row?.isBulkPayment ? row?.charge?.payment?.status : "-"}
          </TableCell>
        } */}
        <TableCell
          className="charged-head main-width-class"
          align="left"
          onClick={() => {
            setDrawerData({ ...row, bulkPaymentFlag: bulkPayment });
            setOpenModal(true);
          }}
        >
          <div
            // style={{ wordBreak: "break-all", whiteSpace: "normal" }}
            className="transaction-charged table-row ellipsDueAmount"
            title={
              bulkPayment && row?.isBulkPayment
                ? numberFormat({
                    number: +row?.charged,
                    decimal: 2,
                    style: "currency",
                  })
                : row?.charge?.discount
                ? row?.charge?.amount + row?.charge?.discount
                : row?.charge?.amount
            }
          >
            {bulkPayment
              ? `${numberFormat({
                  number: +row?.charged,
                  decimal: 2,
                  style: "currency",
                })}`
              : `${numberFormat({
                  number: +(row?.charge?.discount
                    ? row?.charge?.amount + row?.charge?.discount
                    : row?.charge?.amount),
                  decimal: 2,
                  style: "currency",
                })}`}
          </div>
        </TableCell>
        <TableCell
          style={{ wordBreak: "break-all", whiteSpace: "normal" }}
          className="paid-head main-width-class"
          align="left"
          onClick={() => {
            setDrawerData({ ...row, bulkPaymentFlag: bulkPayment });
            setOpenModal(true);
          }}
        >
          <div
            className="transaction-paid table-row ellipsDueAmount"
            title={row?.charge?.paid ?? "N/A"}
          >
            {bulkPayment
              ? `${numberFormat({
                  number: +row?.paid,
                  decimal: 2,
                  style: "currency",
                })}`
              : row?.charge?.paid === 0
              ? "-"
              : `${numberFormat({
                  number: +row?.charge?.paid,
                  decimal: 2,
                  style: "currency",
                })}`}
            {row?.charge?.isInstallment && <InstallmentIcon className="ml-2" />}
          </div>
        </TableCell>
        {!bulkPayment && (
          <TableCell
            style={{ wordBreak: "break-all", whiteSpace: "normal" }}
            className="paid-head main-width-class"
            align="left"
            onClick={() => {
              setDrawerData(row);
              setOpenModal(true);
            }}
          >
            <div
              className="transaction-paid table-row ellipsDueAmount"
              title={
                isNaN(
                  +row?.charge?.amount +
                    row?.charge?.discount -
                    row?.charge?.paid,
                )
                  ? numberFormat({ number: 0, decimal: 2, style: "currency" })
                  : numberFormat({
                      number:
                        +row?.charge?.amount +
                        row?.charge?.discount -
                        row?.charge?.paid,
                      decimal: 2,
                      style: "currency",
                    })
              }
            >
              {isNaN(
                +row?.charge?.amount +
                  row?.charge?.discount -
                  row?.charge?.paid,
              )
                ? numberFormat({ number: 0, decimal: 2, style: "currency" })
                : numberFormat({
                    number:
                      +row?.charge?.amount +
                      row?.charge?.discount -
                      row?.charge?.paid,
                    decimal: 2,
                    style: "currency",
                  })}
            </div>
          </TableCell>
        )}
        <TableCell
          className="ledger-head main-width-class"
          align="left"
          onClick={() => {
            setDrawerData({ ...row, bulkPaymentFlag: bulkPayment });
            setOpenModal(true);
          }}
        >
          <div className="transaction-led-sub table-row">
            <div className="sub">
              {!row?.isBulkPayment ? row?.Ledger?.name : "-"}
            </div>
            <div
              className="led ellipseText"
              title={
                // row?.SubLedger === null &&
                // row?.comment_invoice?.visible === true &&
                // row?.comment_invoice?.note !== null
                // ? row?.comment_invoice?.note
                row?.SubLedger?.name && !row?.isBulkPayment
                  ? row?.SubLedger?.name
                  : "-"
              }
            >
              {
                // row?.SubLedger === null &&
                //   row?.comment_invoice?.visible === true &&
                //   row?.comment_invoice?.note !== null
                //   ? row?.comment_invoice?.note
                //   :
                row?.isBulkPayment
                  ? ""
                  : row?.SubLedger?.name
                  ? row?.SubLedger?.name
                  : "-"
              }
            </div>
          </div>{" "}
        </TableCell>
        {/* <TableCell
          className="transaction-head main-width-class"
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div className="transaction-trans table-row" title={row._id ?? "N/A"}>
            {row._id ? row._id.slice(0, 5) + "..." : "-"}
          </div>{" "}
        </TableCell> */}
        {bulkPayment && (
          <TableCell
            onClick={() => {
              setDrawerData({ ...row, bulkPaymentFlag: bulkPayment });
              setOpenModal(true);
            }}
          >
            {row?.isBulkPayment
              ? row?.paymnetMethod
              : row?.charge?.payment?.History?.paymnetMethod?.method}
          </TableCell>
        )}
        {bulkPayment && (
          <TableCell
            onClick={() => {
              setDrawerData({ ...row, bulkPaymentFlag: bulkPayment });
              setOpenModal(true);
            }}
          >
            {row?.isBulkPayment
              ? row?.bulkPaymentId
              : row?.charge?.payment?.History?._id}
          </TableCell>
        )}
        <TableCell
          className={`exp-action-head main-width-class ${
            batchTable === "batchtable" ||
            bulkPayment ||
            (row?.isRecurring &&
              row?.charge?.sub_status === "declined" &&
              row?.charge?.amount === 0)
              ? ""
              : "sticky-body-column"
          }`}
          align="right"
        >
          <div style={{ cursor: "pointer", paddingleft: "0px" }}>
            {batchTable === "batchtable" ||
            bulkPayment ||
            (row?.isRecurring &&
              row?.charge?.sub_status === "declined" &&
              row?.charge?.amount === 0) ? (
              <></>
            ) : (
              <Action
                style={{ width: "16px" }}
                action="finance"
                reversalCheck={false}
                onEdit="edit"
                chargeStatus={
                  row?.charge?.amount -
                    row?.charge?.paid +
                    row?.charge?.discount >
                    0 &&
                  row?.charge?.amount -
                    row?.charge?.paid +
                    row?.charge?.discount <
                    row?.charge?.amount
                    ? "partially_paid"
                    : row?.charge?.payment?.status
                }
                onPayClick={() => {
                  localStorage.setItem("payNowItem", JSON.stringify(row));
                  onPayNowClick(row);
                }}
                onUpdateClick={() => {
                  onUpdateClick(row);
                }}
                onDeleteClick={() => {
                  onDeleteClick(row);
                }}
                onCancelClick={() => {
                  onCancelClick();
                }}
                onSharePymentClick={() => {
                  onSharePaymentLinkClick(row);
                }}
                onUpdatePaymentClick={() => {
                  onPayNowClick(row);
                }}
                OnRecurringAction={setRecurringAction}
                onReversalClick={() => {
                  
                  setReversalDialog(true);
                  fetchReversalTypes(
                    row?.charge?.status === "charge"
                      ? "charge"
                      : row?.charge?.status === "payment"
                      ? "payment"
                      : "",
                  );
                }}
                onCancelPaymentClick={
                  row?.charge?.installmentDetails?.status === "active"
                    ? () => {
                        onCancelPayment(row);
                      }
                    : null
                }
                setBatchList={setBatchList}
                row={row}
                checkData={checkData}
                disableSharePaymentLink={disableSharePaymentLink}
                disableDeleteButton={isFutureDate(
                  row?.charge?.installmentDetails?.installmentStart,
                )}
                onUpdatePaymentMethod={() => {
                  onUpdatePaymentMethodClick(row);
                }}
                enableUpdatePaymentMethod={enableUpdatePaymentMethod}
              />
            )}
          </div>
          {/* <MainDialog
            loading={Enableloading}
            reversalDialog={reversalDialog}
            open={reversalActionTypes}
            getTypes={getTypes}
            handleClose={handleCloseDialog}
            onDecline={() => {
              setReversalActionTypes(false);
            }}
            onAccept={(id, type, hidden) =>
              onReversalClick(
                row?.charge?.status === "charge"
                  ? {
                    reversal_type: {
                      id: id,
                      type: type,
                      hidden: hidden,
                    },
                    chargeId: row?.charge?._id,
                  }
                  : "",
                setReversalActionTypes
              )
            }
            content={"Choose a reversal type "}
          /> */}
        </TableCell>
      </TableRow>

      {open && bulkPayment ? (
        <>
          <TableRow>
            <TableCell style={{ padding: 0 }} colSpan={14} className="border-0">
              {bulkPaymentLoading ? (
                <div className="w-100 text-center">
                  <CircularProgress size={22} />
                </div>
              ) : (
                <Box>
                  <Typography variant="h6" gutterBottom component="div" />
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow className="MuiTableRow-root-temp">
                        <TableCell variant="body" className="border-0" />
                        <TableCell variant="body" className="border-0" />
                        <TableCell variant="body" className="border-0" />

                        <TableCell variant="body" className="border-0">
                          <span className="bulkCell_header">
                            {"status".toUpperCase()}
                          </span>
                        </TableCell>

                        <TableCell variant="body" className="border-0">
                          <span className="bulkCell_header">
                            {"created date".toUpperCase()}
                          </span>
                        </TableCell>
                        <TableCell variant="body" className="border-0">
                          <span className="bulkCell_header">
                            {"due date".toUpperCase()}
                          </span>
                        </TableCell>
                        <TableCell
                          align="left"
                          variant="body"
                          className="border-0"
                        >
                          <span className="bulkCell_header">
                            {"charged".toUpperCase()}
                          </span>
                        </TableCell>
                        <TableCell
                          align="left"
                          variant="body"
                          className="border-0"
                        >
                          <span className="bulkCell_header">
                            {"Paid".toUpperCase()}
                          </span>
                        </TableCell>
                        <TableCell
                          align="left"
                          variant="body"
                          className="border-0"
                        >
                          <span className="bulkCell_header">
                            {"due".toUpperCase()}
                          </span>
                        </TableCell>
                        <TableCell
                          align="left"
                          variant="body"
                          className="border-0"
                        >
                          <span className="bulkCell_header">
                            {"sub ledger / ledger".toUpperCase()}
                          </span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {bulkPayments?.charges?.map((item) => (
                        <TableRow
                          key={item?._id}
                          className="MuiTableRow-root-temp"
                        >
                          <TableCell
                            className="checkbox-cell border-0"
                            component="td"
                            scope="row"
                            variant="body"
                            onClick={() => {
                              setDrawerData({
                                ...item?.transaction,
                                bulkPaymentCharge: true,
                              });
                              setOpenModal(true);
                            }}
                          />
                          <TableCell
                            className="checkbox-cell border-0"
                            component="td"
                            scope="row"
                            variant="body"
                            onClick={() => {
                              setDrawerData({
                                ...item?.transaction,
                                bulkPaymentCharge: true,
                              });
                              setOpenModal(true);
                            }}
                          />
                          <TableCell
                            className="checkbox-cell border-0"
                            component="td"
                            scope="row"
                            variant="body"
                            onClick={() => {
                              setDrawerData({
                                ...item?.transaction,
                                bulkPaymentCharge: true,
                              });
                              setOpenModal(true);
                            }}
                          />
                          <TableCell
                            component="td"
                            scope="row"
                            variant="body"
                            className="border-0"
                            onClick={() => {
                              setDrawerData({
                                ...item?.transaction,
                                bulkPaymentCharge: true,
                              });
                              setOpenModal(true);
                            }}
                          >
                            <div
                              style={{
                                color: "#9edb9f",
                                fontSize: "13px",
                                fontWeight: "500",
                              }}
                            >
                              {item?.transaction?.charge?.status?.toUpperCase()}
                            </div>
                            <div style={{ fontSize: "13px" }}>
                              {displayPaymentTransactionLine2(item)}
                            </div>
                            <div className="sub-status table-row ">
                              {item?.transaction?.charge?.installmentDetails
                                ?.status
                                ? displayInstallmentStatus(
                                    item?.transaction?.charge
                                      ?.installmentDetails,
                                  )
                                : ""}
                              {item?.transaction?.isRecurring
                                ? displayRecurringStatus(item?.transaction)
                                : ""}
                            </div>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className="border-0"
                            onClick={() => {
                              setDrawerData({
                                ...item?.transaction,
                                bulkPaymentCharge: true,
                              });
                              setOpenModal(true);
                            }}
                          >
                            <div className="transaction-led-sub table-row">
                              {formatDate({
                                date: item?.transaction?.createdAt ?? item?.createdAt,
                                formatType: "defaultWithUTC",
                              })}
                            </div>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className="border-0"
                            onClick={() => {
                              setDrawerData({
                                ...item?.transaction,
                                bulkPaymentCharge: true,
                              });
                              setOpenModal(true);
                            }}
                          >
                            <div className="transaction-led-sub table-row">
                              {formatDate({
                                date: item?.transaction?.charge?.due_date,
                                formatType: "defaultWithUTC",
                              })}
                            </div>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className="finance-table border-0"
                            onClick={() => {
                              setDrawerData({
                                ...item?.transaction,
                                bulkPaymentCharge: true,
                              });
                              setOpenModal(true);
                            }}
                          >
                            <span>
                              {numberFormat({
                                number: +item?.transaction?.charge?.amount,
                                decimal: 2,
                                style: "currency",
                              })}
                            </span>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className="charged-cell border-0"
                            onClick={() => {
                              setDrawerData({
                                ...item?.transaction,
                                bulkPaymentCharge: true,
                              });
                              setOpenModal(true);
                            }}
                          >
                            {" "}
                            <span>
                              {numberFormat({
                                number: +item?.transaction?.charge?.paid,
                                decimal: 2,
                                style: "currency",
                              })}
                            </span>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className="charged-cell border-0"
                            onClick={() => {
                              setDrawerData({
                                ...item?.transaction,
                                bulkPaymentCharge: true,
                              });
                              setOpenModal(true);
                            }}
                          >
                            <div className="transaction-paid table-row ellipsDueAmount">
                              {isNaN(
                                +item?.transaction?.charge?.amount +
                                  item?.transaction?.charge?.discount -
                                  item?.transaction?.charge?.paid,
                              )
                                ? numberFormat({
                                    number: 0,
                                    decimal: 2,
                                    style: "currency",
                                  })
                                : numberFormat({
                                    number:
                                      +item?.transaction?.charge?.amount +
                                      item?.transaction?.charge?.discount -
                                      item?.transaction?.charge?.paid,
                                    decimal: 2,
                                    style: "currency",
                                  })}
                            </div>{" "}
                          </TableCell>
                          <TableCell
                            className="finance-table border-0"
                            onClick={() => {
                              setDrawerData({
                                ...item?.transaction,
                                bulkPaymentCharge: true,
                              });
                              setOpenModal(true);
                            }}
                          >
                            {" "}
                            <div className="finance-table transaction-led-sub table-row ">
                              <div className="sub">
                                {item?.transaction?.Ledger?.name
                                  ? item?.transaction?.Ledger?.name
                                  : "-"}
                              </div>
                              <div className="led">
                                {item?.transaction?.SubLedger?.name
                                  ? item?.transaction?.SubLedger?.name
                                  : "-"}
                              </div>
                            </div>{" "}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              )}
            </TableCell>
          </TableRow>
        </>
      ) : open ? (
        <>
          {row?.charge?.payment?.History?.length > 0 && (
            <>
              <TableRow className="MuiTableRow-root-temp" style={{ height: 32 }}>
                <TableCell variant="body" className="border-0" style={{ width: "5%", padding: "4px 8px" }} />
                <TableCell variant="body" className="border-0" style={{ width: "5%", padding: "4px 8px" }} />
                <TableCell variant="body" className="border-0" style={{ width: "5%", padding: "4px 8px" }} />
                <TableCell variant="body" className="border-0" style={{ padding: "4px 8px" }}><span className="bulkCell_header">STATUS</span></TableCell>
                <TableCell variant="body" className="border-0" style={{ padding: "4px 8px" }}><span className="bulkCell_header">PAYMENT DATE</span></TableCell>
                <TableCell variant="body" className="border-0" style={{ padding: "4px 8px" }}><span className="bulkCell_header">AMOUNT</span></TableCell>
                <TableCell variant="body" className="border-0" style={{ padding: "4px 8px" }}><span className="bulkCell_header">PAYMENT METHOD</span></TableCell>
                {/* fills the rest of the row; one column less when the Account column is hidden (member Finances tab) so sub-rows end where the main rows do */}
                <TableCell variant="body" className="border-0" style={{ padding: "4px 8px" }} colSpan={hideAccountName ? 4 : 5} />
              </TableRow>
                      {row?.charge?.payment?.History?.map((item) => (
                        <TableRow key={item._id} className="child_exp_row" style={{ background: "#f3f6f969" }}>
                          <TableCell className="border-0" style={{ width: "5%" }} />
                          <TableCell className="border-0" style={{ width: "5%" }} />
                          <TableCell className="border-0" style={{ width: "5%" }} />
                          <TableCell className="border-0" onClick={() => { modifyRowData(row, { ...item, isExpandRow: true }); }}>
                            <div className="status" style={{ color: "#81DC91" }}>PAYMENT</div>
                            <div className={item?.is_reversed ? "toaster-message" : "transaction-account-name transaction-subrow-status table-row"}>
                              {item?.is_reversed ? "Reversed" : "Paid"}
                            </div>
                          </TableCell>
                          <TableCell className="border-0" onClick={() => { modifyRowData(row, { ...item, isExpandRow: true }); }}>
                            <div>{formatDate({ date: item?.created_at, formatType: "defaultWithUTC" })}</div>
                          </TableCell>
                          <TableCell className="border-0" onClick={() => { modifyRowData(row, { ...item, isExpandRow: true }); }}>
                            <div>{item?.amount === 0 ? "-" : numberFormat({ number: +item?.amount, decimal: 2, style: "currency" })}</div>
                          </TableCell>
                          <TableCell className="border-0" onClick={() => { modifyRowData(row, { ...item, isExpandRow: true }); }}>
                            <div>{item?.paymnetMethod?.method?.replace(/_/g, " ") ?? "-"}</div>
                          </TableCell>
                          <TableCell className="border-0" colSpan={hideAccountName ? 3 : 4} onClick={() => { modifyRowData(row, { ...item, isExpandRow: true }); }} />
                <TableCell
                  className="icon-cell"
                  style={{ position: "sticky", right: 0, backgroundColor: "#fafbfc" }}
                >
                  {!item?.is_reversed && (
                    <div style={{ cursor: "pointer", paddingleft: "0px" }}>
                      <Action
                        style={{ width: "16px" }}
                        reversalCheck={true}
                        action="finance"
                        onSharePaymentLinkClick={() =>
                          onSharePaymentLinkClick(row)
                        }
                        onReversalClick={() => {
                         
                          setDialogPaymentId(item?._id)
                          setReversalDialog(true);
                          item?.isBulkPayment?  setConfirmBulkReversal(true):
                          fetchReversalTypes(
                            row?.charge?.status === "charge"
                              ? "charge"
                              : row?.charge?.status === "payment"
                                ? "payment"
                                : "",
                            row?.charge?._id,
                            item._id
                          );
                          
                        }}
                        row={item}
                        rowId={item?.is_reversed}
                      />
                    </div>
                  )}
                  <AlertDialog
                    open={confirmBulkReversal}
                      maxWidth="lg" 
                      useFlex={false}      
  fullWidth={true}   
    PaperProps={{
    style: {
      width: "1000px",
      maxWidth: "1000px",
    },
  }}         
                    handleClose={() => setConfirmBulkReversal(false)}
                    onDecline={() => {
                      setConfirmBulkReversal(false);
                    }}
                    onAccept={() => {
                      // handleSubmit();
                      setConfirmBulkReversal(false);
                      
                      fetchReversalTypes(
                        row?.charge?.status === "charge"
                          ? "charge"
                          : row?.charge?.status === "payment"
                          ? "payment"
                          : "",
                        row?.charge?._id,
                        item._id,
                      );
                      
                    }}
                    title="Are you sure?"
                    description={
                      <>
                        {
                          "This payment is part of a bulk payment . Reversing it will reverse all payments included in this bulk payment."
                        }
                         <div className="batch-table-modal" style={{
                                 width:'1000px !important',
                             display: 'flex',
                             flexDirection: 'column',
                             alignItems: 'center',
                                  height: "300px",
                             overflowY: "auto", 
                             marginTop:"10px"
                                }}>
                          <BulkPaymentTable
                            tableModel={false}
                            setTableModel={() => {}}
                            page={0}
                          switchType = "payment"
                            setGoSetting={() => {}}
                            goSetting={false}
                            rowsPerPage={30}
                            setRowsPerPage={() => {}}
                            setPage={() => {}}
                           
                            loading={loading}
                            setLoading={setLoading}
                             filters={{
    filter: {
      id: row?.charge?.payment?.History?.[0]?.bulkPaymentId,  
      hidden:true,

    },
    sort: {},
  }}
                            sortData={{}}
                            sortCharged={() => {}}
                            paymentExpandable={true}
                            setPaymentExpandable={() => {}}
                            batchList={false}
                            setBatchList={() => {}}
                            resetChecks={false}
                            setResetchecks={() => {}}
                            setSwitchType={() => {}}
                            bulkPayment={true}
                            toggle="Transactions"
                            showTabs={false}
                            showPagination={false}
                            isEmbeddedInDialog={true}
                            showSelection={false} 
                            showAccountName={false}
                          />
                        </div>
                        {/* below is working if we want expandable row*/}
                        {/* <div className="batch-table-modal" style={{
                                 width:'1000px !important',
                                  // height: "350px",
    // overflowY: "auto", 
                                }}>
                          <ChargesTable
                            tableModel={false}
                            setTableModel={() => {}}
                            page={0}
                          switchType = "payment"
                            setGoSetting={() => {}}
                            goSetting={false}
                            rowsPerPage={30}
                            setRowsPerPage={() => {}}
                            setPage={() => {}}
                           
                            loading={loading}
                            setLoading={setLoading}
                             filters={{
    filter: {
      id: item?._id,  
      hidden:true,

    },
    sort: {},
  }}
                            sortData={{}}
                            sortCharged={() => {}}
                            paymentExpandable={true}
                            setPaymentExpandable={() => {}}
                            batchList={false}
                            setBatchList={() => {}}
                            resetChecks={false}
                            setResetchecks={() => {}}
                            setSwitchType={() => {}}
                            bulkPayment={true}
                            toggle="Transactions"
                            showTabs={false}
                            showPagination={false}
                            isEmbeddedInDialog={true}
                            showSelection={false} 
                            showAccountName={false}
                          />
                        </div> */}
                          {/* <div className="batch-table-modal" style={{
                                  maxWidth: '1000px'
                                }}>
                                  <ChargesTable
                                    checkbatchBillingTable={true}
                                    batchbillingShow={true}
                                    rowsPerPage={rowsPerPage}
                                    setRowsPerPage={setRowsPerPage}
                                    setPage={setFinanceTablePage}
                                    list={financeData}
                                    batchDataCount={batchDataCount}
                                    setBatchDataCount={setBatchDataCount}
                                    finance={finance}
                                    filters={chargeSorting}
                                    page={financeTablePage ?? 0}
                                    sortCharged={chargedSorting}
                                    batchTable="batchtable"
                                    setBatchList={setBatchList}
                                    showTabs={false}
                                  />
                                </div> */}
                      </>
                    }
                  />

                  <MainDialog
                    loading={Enableloading}
                    reversalDialog={reversalDialog}
                    open={reversalActionTypes}
                    getTypes={getTypes}
                    handleClose={handleCloseDialog}
                    onDecline={() => {
                      setReversalActionTypes(false);
                    }}
                    onAccept={(id, type, hidden) =>
                      
                     onReversalClick(
                        row?.charge?.status === "charge"
                          ? { chargeId: row?.charge?._id }
                          : row?.charge?.status === "payment"
                          ? {
                              reversal_type: {
                                id: id,
                                type: type,
                                hidden: hidden,
                              },
                              chargeId: chargeId,
                              paymentId: dialogPaymentId,
                            }
                          : "",
                        setReversalActionTypes,
                      )
                    }
                    content={"Choose a reversal type"}
                    minHeight={"40%"}
                  />
               
                        </TableCell>
                        </TableRow>
                      ))}
            </>
          )}
        </>
      ) : null}
      {openCancleModalDialog && (
        <AlertDialog
          open={openCancleModalDialog}
          handleClose={handleCloseDialog}
          onDecline={() => {
            setOpenCancleModalDialog(false);
          }}
          onAccept={() => {
            handelSubmit();
            // onSelectedPayment(row);
          }}
          title={"Are you sure?"}
          description={"Do you want to cancel this transaction?"}
        />
      )}

      <AlertDialog
        open={confirmClose}
        handleClose={() => setConfirmClose(false)}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={`Do you want to discard the changes you made?`}
      />
    </React.Fragment>
  );
};

export default memo(ExpandableRow);
